import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// Assets
import userProfileStyles from "./userProfileStyles.jsx"
import CardHeader from "../../components/CardHeader";
import { primaryColor } from "../../assets/jss/material-dashboard-pro-react";
import GridContainer from "../../components/GridContainer";
import GridItem from "../../components/GridItem";
import Card from "../../components/Card";
import CardBody from "../../components/CardBody";
import Table from "../../components/Table";
import CustomInput from "../../components/CustomInput";
import Button from "../../components/CustomButtons";
import { managementService } from "../../_services";
import { connect } from "react-redux";
import { sweetAlertActions } from "../../_actions";
import { update_device_lists } from "../helper_functions/device_icons";
import MyDropdown from "../../components/MyDropdown";
import { getUserType } from "../../_services/authenticate.js";
import { Alert } from "@mui/material";


class AddDevice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      device_serial: "",
      name: "",
      client_name: "",
      device_type: "",
      hardware_revision_id: null,
      all_device_types: [],
      is_creating: false,
      device_generation_result: {},

      production_locations: [{
        id: "OAG1",
        name: "Octinion Agriculture Production"
      },
      {
        id: "OBE1",
        name: "Octiva Production"
      },
      {
        id: "OBE2",
        name: "Berkvens Greenhouse Mobility"
      },
      {
        id: "OBE3",
        name: "3rd Party Production"
      }],
      production_location: "",
      organisation_id: null,
      vehicle_configuration: "",
      location_id: null,
    }
  }

  componentDidMount() {
    managementService.getAllDeviceTypes(res => {
      this.setState({ all_device_types: res.result })
    })
    this.validateDeviceCreationInput()
  }

  change(event, stateName) {
    this.setState({
      [stateName]: event.target.value
    }, () => this.validateDeviceCreationInput())
  }

  create_device() {
    const { device_serial, name, client_name, device_type, hardware_revision_id } = this.state
    const { dispatch } = this.props
    this.setState({ is_creating: true })
    managementService.createDevice(device_serial, name, client_name, device_type, hardware_revision_id, res => {
      if (res.result) {
        update_device_lists()
        dispatch(sweetAlertActions.success({ title: "The device is created" }))
        this.setState({ device_serial: "", name: "", client_name: "" })
      } else {
        dispatch(sweetAlertActions.danger("Something went wrong while creating the device"))
      }
      this.setState({ is_creating: false })
    })
  }

  start_create_device() {
    const { dispatch } = this.props
    const { device_serial, name, client_name, device_type, hardware_revision_id } = this.state

    if (device_serial === "") {
      dispatch(sweetAlertActions.danger({
        title: "Error",
        content: <div>
          <h5>You cannot add a device without a serial number</h5>
        </div>
      }))
    } else {
      dispatch(sweetAlertActions.clean({
        title: "Are you sure?",
        showCancel: true,
        onCancel: this.clear_popup.bind(this),
        cancelBtnText: "No",
        onConfirm: this.create_device.bind(this),
        confirmBtnText: "Yes",
        content: <div>
          <h5>You will add a device with next information</h5>
          <p><b>Device Serial:</b> {device_serial}</p>
          <p><b>Name:</b> {name}</p>
          <p><b>Client Name:</b> {client_name}</p>
          <p><b>Device Type:</b> {device_type}</p>
          {
            hardware_revision_id ?
              <p><b>Hardware Revision ID:</b> {hardware_revision_id}</p>
              :
              <p><b>Hardware Revision ID:</b> No Revision</p>

          }
          <br />
          <p>Are you sure all information is correct?</p>
          <p>A device cannot be removed from the system once it has been created.</p>
        </div>
      }))
    }
  }

  clear_popup() {
    const { dispatch } = this.props;
    dispatch(sweetAlertActions.clear())
  }

  handleDeviceType(name, value) {
    const { all_device_types } = this.state
    let hardware_revision_id = null
    let production_location = null


    let rev_options = []
    all_device_types.forEach(type => {
      if (type["id"] === value) {
        rev_options = type["revisions"]
      }
    })

    if (rev_options.length > 0) {
      hardware_revision_id = rev_options[rev_options.length - 1].revision_id
    }

    switch (value) {
      case "UVP04":
      case "UVP03":
      case "BUG01":
      case "XENION_A6":
      case "UNKNOWN":
      case "DSS01":
      case "DBD01":
      case "DIL01":
      case "IDK01":
        production_location = "OBE1"
        break;

      case "UVP06":
      case "UVP02":
      case "UVP01":
      case "TSB01":
      case "SCT01":
      case "DIV01":
      case "XENION_CONNECT":
        production_location = "OBE2"
        break;

      case "SPR01":
      case "KOMPANO":
        production_location = "OBE3"
        break;

      case "LUMION_FIX":
        production_location = "OAG1"
        break;

      default:
        production_location = "OBE1"
    }

    this.setState({
      "device_type": value,
      "hardware_revision_id": hardware_revision_id,
      "production_location": production_location
    }, () => this.validateDeviceCreationInput())
  }

  clearData() {
    this.setState({
      device_serial: "",
      name: "",
      client_name: "",
      device_type: "",
      hardware_revision_id: null,
      is_creating: false,
      production_location: "",
      device_generation_result: {},
      vehicle_configuration: "",
      organisation_id: "",
      location_id: "",
    }, () => this.validateDeviceCreationInput())
  }

  validateDeviceCreationInput() {
    const { organisation_id, location_id, device_generation_result, all_device_types, name, client_name } = this.state
    let validated = true
    let error_message = ""
    let warning_message = ""

    if (!device_generation_result || Object.keys(device_generation_result).length === 0) {
      error_message = "Please generate the device information to see if there are any warnings regarding the device you want to create."
      validated = false
    } else {
      let rev_options = []
      all_device_types.forEach(type => {
        if (type["id"] === device_generation_result.device_type) {
          rev_options = type["revisions"]
        }
      })

      if (device_generation_result.device_serial === "" || device_generation_result.device_type === "" || device_generation_result.production_location === "") {
        error_message = "Device Serial, Device Type and Production Location are required to create a device, please fill in the missing information and generate the device information again."
        validated = false
      }

      if (!name) {
        error_message = "Name is required to create a device, please fill in the name or generate the device information again to get a proposed name."
        validated = false
      }

      if (!client_name) {
        error_message = "Client Name is required to create a device, please fill in the client name or generate the device information again to get a proposed client name."
        validated = false
      }

      if (rev_options.length > 0 && !this.state.hardware_revision_id) {
        error_message = "Please select a hardware revision for the device type you have selected."
        validated = false
      }

      if (device_generation_result.device_type === "XENION_CONNECT" && !this.state.vehicle_configuration) {
        error_message = "Please fill in the vehicle configuration for the XENION_CONNECT device type."
        validated = false
      }
    }

    if (!location_id) {
      warning_message = "Device will not be deployed automatically when no location is selected."
    }

    if (!organisation_id) {
      warning_message = "Name will not be automatically generated or device won't be deployed when you do not select an organisation."
    }

    this.setState({ error_message, warning_message })
    return validated
  }

  createDeviceV2() {
    const { device_generation_result, hardware_revision_id, name, client_name, organisation_id, location_id, vehicle_configuration } = this.state
    const { dispatch } = this.props
    if (!this.validateDeviceCreationInput()) {
      dispatch(sweetAlertActions.danger({
        title: "Error",
        content: <div>
          <h5>You need to fill in all required fields to create a device</h5>
        </div>
      }))
      return
    }
    this.setState({ is_creating: true })
    managementService.createDeviceV2(device_generation_result.device_serial, device_generation_result.device_type, hardware_revision_id, device_generation_result.production_location, vehicle_configuration, name, client_name, organisation_id, location_id, res => {
      if (res.result) {
        update_device_lists()
        dispatch(sweetAlertActions.clean({
          title: "The device is created!",
          content: res.warning ? <Alert color="warning">{res.warning}</Alert> : null
        }))
        this.setState({ device_serial: "", name: "", client_name: "", device_generation_result: {}, vehicle_configuration: "" })
      } else {
        dispatch(sweetAlertActions.danger("Something went wrong while creating the device"))
      }
      this.setState({ is_creating: false })
    })
  }

  deviceCreationInputGeneration() {
    // This function will query the device information based on the selected organisation and location, this is just a helper function to make it easier for the user to create a device, but the generated information can be changed if needed.
    const { device_serial, device_type, production_location, organisation_id, location_id } = this.state
    managementService.generateDeviceInformation(device_serial, device_type, production_location, organisation_id, location_id, res => {
      if (res) {
        this.setState({
          device_generation_result: res,
          name: res.name,
          client_name: res.client_name,
        }, () => this.validateDeviceCreationInput())
      }
    })
  }

  handle_form_input_selector(name, value) {
    this.setState({ [name]: value }, () => this.validateDeviceCreationInput())
  }

  render() {
    const { organisations, locations } = this.props
    const { all_device_types, is_creating, device_type, organisation_id, location_id, device_serial, production_locations, device_generation_result, hardware_revision_id } = this.state
    const { warning_message, error_message } = this.state

    let rev_options = []
    all_device_types.forEach(type => {
      if (type["id"] === device_type || type["id"] === device_generation_result.device_type) {
        rev_options = type["revisions"]
      }
    })

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader>
              <h4 style={{ color: primaryColor }}><b>Create Device</b></h4>
              <h6>Here you can add a new device to the system, once a device is created it cannot be removed from the system.</h6>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <p>
                    An organisation and location can be selected to automatically deploy the device. When selecting this it will also propose
                    a client name based on the organisation and location, but this can be changed if needed.
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <p><b>Organisation:</b> The organisation to which the device belongs.</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                  <MyDropdown
                    input_label={"Organisation"}
                    name={"organisation_id"}
                    value={organisation_id}
                    default_value={organisation_id}
                    options={[...Object.keys(organisations).sort((a, b) => {
                      return organisations[a]["name"] < organisations[b]["name"] ? -1 : 1
                    }).map((org_id) => {
                      return { id: org_id, value: organisations[org_id].name }
                    })]}
                    handle_selection={this.handle_form_input_selector.bind(this)}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <Button onClick={()=>this.setState({organisation_id: null, location_id: null})} color="warning">Clear</Button>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <p><b>Location:</b> Where the device should be deployed.</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={5}>
                  <MyDropdown
                    input_label={"Location"}
                    name={"location_id"}
                    value={location_id}
                    default_value={location_id}
                    options={[...Object.keys(locations).filter((location_id) => {
                      return locations[location_id]["owned_by"] === organisation_id;
                    }).sort((a, b) => {
                      return locations[a]["name"] < locations[b]["name"] ? -1 : 1
                    }).map((location_id) => {
                      return {
                        id: location_id, value: locations[location_id]["name"]
                      }
                    })]}
                    handle_selection={this.handle_form_input_selector.bind(this)}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <Button onClick={() => this.setState({ location_id: null })} color="warning">Clear</Button>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <hr />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <p>
                    You can choose to fill in the serial number for the device or select the device type and generate one.
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <p><b>Device Serial:</b></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    id={"device_serial"}
                    labelText={"Device Serial"}
                    inputProps={{
                      onChange: event => this.change(event, "device_serial"),
                      type: "text",
                      value: device_serial
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3} style={{ borderLeft: "1px solid #dedede", paddingLeft: "10px" }}>
                  <p><b>Device Type:</b></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <MyDropdown
                    input_label={"Choose Device Type"}
                    name={"device_type"}
                    value={this.state["device_type"]}
                    handle_selection={
                      this.handleDeviceType.bind(this)
                    }
                    options={[
                      ...all_device_types.map(function (item, key) {
                        return {
                          id: item.id,
                          value: `${item.id} - ${item.name}`
                        }
                      })
                    ]}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <p></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <p></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={3} style={{ borderLeft: "1px solid #dedede", paddingLeft: "10px" }}>
                  <p><b>Production Location:</b></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <MyDropdown
                    input_label={"Choose Production Location"}
                    name={"production_location"}
                    value={this.state["production_location"]}
                    handle_selection={
                      this.handle_form_input_selector.bind(this)
                    }
                    options={[
                      ...production_locations.map(function (item, key) {
                        return {
                          id: item.id,
                          value: `${item.id} - ${item.name}`
                        }
                      })
                    ]}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                  <Button onClick={this.clearData.bind(this)} color="warning">Clear Data</Button>
                  <Button onClick={this.deviceCreationInputGeneration.bind(this)} color="primary">Generate Information</Button>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <hr />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <p><b>Device Serial:</b></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  {device_generation_result.device_serial ? device_generation_result.device_serial : "No Serial Generated"}
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <p><b>Production Location:</b></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  {device_generation_result.production_location ?
                  production_locations.find(p_loc => p_loc.id === device_generation_result.production_location).name
                  :
                  "No Production Location Selected"}
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <p><b>Device Type:</b></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  {device_generation_result.device_type ?
                  all_device_types.find(d_type => d_type.id === device_generation_result.device_type).name : "No Device Type Selected"}
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <p><b>Hardware Revision ID:</b></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  {rev_options.length > 0 ?
                    <MyDropdown
                      input_label={"Choose Hardware Revision"}
                      name={"hardware_revision_id"}
                      value={hardware_revision_id}
                      handle_selection={
                        this.handle_form_input_selector.bind(this)
                      }
                      options={[
                        ...rev_options.map(function (item, key) {
                          return {
                            id: item.revision_id,
                            value: `${item.revision_id}`
                          }
                        })
                      ]}
                    /> :
                    "No options available for this device type"
                  }
                </GridItem>
                {device_generation_result.device_type === "XENION_CONNECT" &&
                <>
                  <GridItem xs={12} sm={12} md={6}>
                    <p><b>Vehicle Configuration:</b></p>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      id={"vehicle_configuration"}
                      labelText={"Vehicle Configuration"}
                      inputProps={{
                        onChange: event => this.change(event, "vehicle_configuration"),
                        type: "text",
                        value: this.state["vehicle_configuration"]
                      }}
                    />
                  </GridItem>
                  </>
                }
                <GridItem xs={12} sm={12} md={12}>
                  <hr />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <p><b>Name:</b></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    id={"name"}
                    labelText={"Name"}
                    inputProps={{
                      onChange: event => this.change(event, "name"),
                      type: "text",
                      value: this.state["name"]
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <p><b>Name for Client:</b></p>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    id={"client_name"}
                    labelText={"Client Name"}
                    inputProps={{
                      onChange: event => this.change(event, "client_name"),
                      type: "text",
                      value: this.state["client_name"]
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                  {error_message && <Alert severity="error">{error_message}</Alert>}
                  {warning_message && <Alert severity="warning">{warning_message}</Alert>}
                  <Button onClick={this.createDeviceV2.bind(this)} color="primary" disabled={!!error_message}>Create Device</Button>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>

          {getUserType() === "system_admin" &&
            // Original way of adding a device, let this work for system admins to not be able to add devices with non traditional serial numbers
            <Card>
              <CardHeader><h4 style={{ color: primaryColor }}><b>Add Device</b></h4></CardHeader>
              <CardBody>
                <Table
                  color={"primary"}
                  tableData={[[<p>Device Serial:</p>, <CustomInput
                    id={"device_serial"}
                    labelText={"Device Serial"}
                    inputProps={{
                      onChange: event => this.change(event, "device_serial"),
                      type: "text",
                      value: this.state["device_serial"]
                    }}
                  />], [<p>Name:</p>, <CustomInput
                    id={"name"}
                    labelText={"Name"}
                    inputProps={{
                      onChange: event => this.change(event, "name"),
                      type: "text",
                      value: this.state["name"]
                    }}
                  />, ''], [<p>Client Name:</p>, <CustomInput
                    id={"client_name"}
                    labelText={"Client Name"}
                    inputProps={{
                      onChange: event => this.change(event, "client_name"),
                      type: "text",
                      value: this.state["client_name"]
                    }}
                  />, ''], [<p>Device Type:</p>,
                  <MyDropdown
                    input_label={"Choose Device Type"}
                    name={"device_type"}
                    value={this.state["device_type"]}
                    handle_selection={
                      this.handleDeviceType.bind(this)
                    }
                    options={[
                      ...all_device_types.map(function (item, key) {
                        return {
                          id: item.id,
                          value: `${item.id} - ${item.name}`
                        }
                      })
                    ]}
                  />, ''], [<p>Hardware Revision ID:</p>,
                  rev_options.length > 0 ?
                    <MyDropdown
                      input_label={"Choose Hardware Revision"}
                      name={"hardware_revision_id"}
                      value={this.state["hardware_revision_id"]}
                      handle_selection={
                        this.handle_form_input_selector.bind(this)
                      }
                      options={[
                        ...rev_options.map(function (item, key) {
                          return {
                            id: item.revision_id,
                            value: `${item.revision_id}`
                          }
                        })
                      ]}
                    /> :
                    "No options available for this device type"

                    , ''],

                  [<p>By clicking create you will create a new device, this
                    cannot be undone</p>, <Button disabled={is_creating} color={"primary"}
                      onClick={this.start_create_device.bind(this)}>
                    Create
                  </Button>, ''], ["", "", '']]} />
              </CardBody>
            </Card>
          }
        </GridItem>
      </GridContainer >)
  }
}


function mapStateToProps(state) {
  const { locations, organisations } = state.location

  return {
    locations, organisations
  }
}

export default withStyles(userProfileStyles)(connect(mapStateToProps)(AddDevice))